import '../../Assets/Styles/register.css';
import '../../Assets/Styles/Footer.css';
import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { Button } from 'primereact/button'; 
import { Dialog } from 'primereact/dialog';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import logoFooter from '../../Assets/Images/logoFooter.svg';
import instagramFooterIcon from '../../Assets/Images/instagramFooterIcon.svg';
import facebookFooterIcon from '../../Assets/Images/facebookFooterIcon.svg';

// Load Actions
import * as AppActions from '../../Store/Actions/App';

// UpdateService dialog component
const FooterView = (props) => {

// set vars from props
const {
	alert,
	setAlert,
	alertTitle,
	alertBody,
	alertAction,
	scrollBlock,
	setDialog,
    loginStatus,
    setLoginStatus,
    setActivationStatus,
    activationStatus,
    setCurrentCompanyStatus,
    currentCompanyStatus    
} = props;		

// set Use of history for PUSH 
var navigate = useNavigate();
    

	return (
	<>
        <div className="wrapper__footer">
            <div className="wrapper__footer_container">
                
                    <div className="wrapper__footer_container_left">

                        <div className="logo"><img src={logoFooter} className="noSelect" /></div>
                        <div className="wrapper">

                            <div className="block">
                                <div className="title">Empresa</div>
                                <div className="content">
                                Razão Social: Estação do Olho Ltda<br /> 
                                CNPJ: 52.620.966/0001-25
                                </div>
                            </div>
                            
                            <div className="block">
                            <div className="title">Explore</div>
                                <div className="content">
                                    <a href="javascript:void(0)" onClick={() => navigate("/")} >Encontre clínicas, médicos ou óticas</a>
                                    <a href="javascript:void(0)" onClick={() => navigate("/parceiros")} >Seja Parceiro</a>
                                    <a href="javascript:void(0)" onClick={() => navigate("/noticias")} >Conheça nosso blog</a>
                                    {/*<a href="#">Fazer login na área do cliente</a>*/}
                                    <a href="javascript:void(0)" onClick={() => navigate("/parceiros/painel")} >Acessar área do parceiro</a>
                                </div>
                            </div>

                            <div className="block">
                                <div className="title">A Estação do Olho</div>
                                <div className="content">
                                    <a href="https://wa.me/5521976121000" target="_blank" rel="noopener noreferrer">
                                        Whatsapp: +55 21 97612-1000
                                    </a>
                                    <a href="javascript:void(0)" onClick={() => navigate("/termos/uso")} >Termos de Uso</a>
                                    <a href="javascript:void(0)" onClick={() => navigate("/termos/privacidade")} >Políticas de privacidade</a>
                                    <a href="javascript:void(0)" onClick={() => navigate("/termos/cookies")} >Preferência de cookies</a>                               
                                </div>  
                            </div>

                        </div> 

                    </div>

                    <div className="wrapper__footer_container_right"> 

                    <div className="wrapper">

                        <div className="block">
                          
                            <div className="socialMedia">
                                <div className="socialMedia_title"><a href="https://www.instagram.com/estacaodoolho/" target="_blank">@estacaodoolho</a></div>
                                <div className="socialMedia_icon"><a href="https://www.instagram.com/estacaodoolho/" target="_blank"><img src={instagramFooterIcon} className="noSelect" /></a></div>
                            </div>
                            <div className="socialMedia">
                                <div className="socialMedia_title"><a href="https://facebook.com/estacaodoolho" target="_blank">/estacaodoolho</a></div>
                                <div className="socialMedia_icon"><a href="https://facebook.com/estacaodoolho" target="_blank"><img src={facebookFooterIcon} className="noSelect" /></a></div>
                            </div>

                        </div>

                    </div> 

                    </div>

            </div>
            <div className="wrapper__footer_bottom">
                <div>TODOS OS DIREITOS RESERVADOS © 2025</div>
                <div>Website by Kindle</div>
            </div>
        </div>
	</>	
	);
	
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(FooterView);	
